import { getLoggerSingleton } from './initializer'

/**
 * To get a named Logger instance.
 */
const getLogger = key => getLoggerSingleton().getLogger(key)

export default getLogger
